import type { BonusInfoConfig } from '../../bonusInfo.types.ts';

const BONUS_INFO: BonusInfoConfig = {
  showMaxLimits: false,
};

export { BONUS_INFO };
